import { Injectable } from '@angular/core';

import { SSOService } from '@bn/primitives';

export type LastUsedLoginProvider = SSOService | 'email';

const LAST_USED_PROVIDER_KEY = 'lastUsedLoginProvider';
const VALID_PROVIDERS: LastUsedLoginProvider[] = [...Object.values(SSOService), 'email'];

@Injectable({
  providedIn: 'root',
})
export class LastUsedProviderService {
  public get(): LastUsedLoginProvider | null {
    try {
      const value = localStorage.getItem(LAST_USED_PROVIDER_KEY) as LastUsedLoginProvider | null;

      return value && VALID_PROVIDERS.includes(value) ? value : null;
    } catch {
      return null;
    }
  }

  public set(provider: LastUsedLoginProvider): void {
    try {
      localStorage.setItem(LAST_USED_PROVIDER_KEY, provider);
    } catch {
      // localStorage unavailable (private mode/quota) — feature is cosmetic, ignore
    }
  }
}
